import Vue from 'vue'
import Show from './Show'
import Edit from './Edit'

Vue.component('TrackDeviceShowForm', Show)
Vue.component('TrackDeviceEditForm', Edit)
